/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { IToysrusFooterViewProps } from './toysrus-footer';
const ToysrusFooterView: React.FC<IToysrusFooterViewProps> = (props) => {
  const { toysrusFooter } = props;
  return (
    <div className='footer-collapse'>
      <div className='col-lg-12 col-md-12 col-sm-12'>
        <div className='row toysrus-footer-row'>{toysrusFooter}</div>
        <div className='seprator' />
        <div className='row toysrus-footer-row'>
          <div className='col-lg-3 col-md-3 text-align-center'>
            <h4 className='follow-us'>{props.config.followUs}</h4>
            <ul className='social-ul'>
              <li>
                <a href={props.config.fbLink} target='_blank'>
                  <img
                    className='social-icon'
                    alt='facebook'
                    src='https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MEifDZ?pubver=1'
                  />
                </a>
              </li>
              <li>
                <a href={props.config.twitterLink} target='_blank'>
                  <img
                    className='social-icon'
                    alt='twitter'
                    src='https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MEifE5?pubver=1'
                  />
                </a>
              </li>
              <li>
                <a href={props.config.instagramLink} target='_blank'>
                  <img
                    className='social-icon'
                    alt='instagram'
                    src='https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MEifE2?pubver=1'
                  />
                </a>
              </li>

              <li>
                <a href={props.config.youTubeLink} target='_blank'>
                  <img
                    className='social-icon'
                    alt='YouTube'
                    src='https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MEi5eG?pubver=1'
                  />
                </a>
              </li>
              <li>
                <a href={props.config.whatsAppLink} target='_blank'>
                  <img
                    className='social-icon'
                    alt='WhatsApp'
                    src='https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MEiifn?pubver=1'
                  />
                </a>
              </li>
              <li>
                <a href={props.config.tiktokLink} target='_blank'>
                  <img
                    className='social-icon'
                    alt='Tiktok'
                    src='https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MEi5eJ?pubver=1'
                  />
                </a>
              </li>
            </ul>
      
      <br></br>
      <ul className="social-ul play-store">
         <li><a href="https://play.google.com/store/apps/details?id=sa.com.toysrus" target="_blank"><img className="social-icon" alt="google play" src="https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/ME3OJA?pubver=0"/></a></li>
         <li><a href="https://apps.apple.com/app/my-app/id1618228069" target="_blank"><img className="social-icon" alt="apple store" src="https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/ME3OJD?pubver=1"/></a></li>
      </ul>


          </div>


          <div className='col-lg-6 col-md-6 copy-div text-align-center'>





          <h4 className="follow-us we-accept" > {props.config.weAccept}</h4>

    <ul className="social-ul">



         <li><img className="social-icon" alt="american-express" src="https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/ME3RkP?pubver=1"/></li>

         <li><img className="social-icon" alt="master-card" src="https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/ME3RkM?pubver=1"/></li>

         <li><img className="social-icon" alt="visa" src="https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/ME3Z8B?pubver=1"/></li>

         <li><img className="social-icon" alt="mada" src="https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/ME3GVG?pubver=1"/></li>

         <li><img className="social-icon" alt="apple-pay" src="https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/ME3Ekm?pubver=1"/></li>

        
      </ul>
      <br></br>




      





            
          </div>





          <div className='col-lg-3 col-md-3 legal-logo-containerx text-align-center'>


          <img className='gerrofry-logo'  src="https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/ME3M8c?pubver=0" alt="ToysRUs"  />


            <a
              href={props.config.maroofLink}
              target='_blank'
              className='legal-logo-link display-none'
            >
              <img
                src='https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZZy'
                alt='maroof'
                className='maroof-logo'
              />
            </a>

            <img
              src='https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1Usc'
              alt='tasweeq'
              className='tasweeq-logo legal-logo-link display-none'
            />

            <a
              href={props.config.vatLink}
              target='_blank'
              className='legal-logo-link vat-logo display-none'
            >
              <img
                src='https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/ME3WD3?pubver=0'
                alt='vat'
                className='vatt-logo'
              />
            </a>



            

 

          </div>
        </div>



        <div className="row toysrus-footer-row text-align-center copy-right-div" >
          <div className="col-lg-12 col-md-12 copy-div text-align-center">
            <ul className="social-ul copyright-desktop">
              <li><img className="tasweeq-logo-new" alt="american-express" src="https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1Usc"/></li>
              <li className="copywright-text" ><span>{ReactHtmlParser(props.config.copyRightText)}</span></li>
            </ul>
          </div>
        </div>




      </div>
    </div>
  );
};
export default ToysrusFooterView;
